import { ConditionName, IParamsErrorPopoverProps } from "interfaces";
import Popover from "../popover/popover";
import IMAGES from "images";
import Image from "next/image";
import { conditions } from "helpers";

const ParamsErrorPopover = ({ requiredsItems, notRequiredsItems }: IParamsErrorPopoverProps) => {
    const customHeader = (
        <div className="pl-flex pl-items-center pl-gap-2 pl-py-[18px]">
            <Image src={IMAGES.danger} width={24} height={24} />
            <p className="pl-text-z-gray-700 pl-text-[18px] pl-font-bold">خطایی رخ داده است!</p>
        </div>
    );

    return (
        <Popover type="modal" status={true} onClose={() => {}} isHeader={true} customHeader={customHeader} classNames="pl-w-full pl-h-full">
            <div className="pl-mt-[51px] pl-text-center">
                <div className="pl-mb-[50px]">
                    {!conditions(ConditionName.hasAllParams) && (
                        <p className="pl-mb-4">
                            پارامتر جدیدی در redux تعریف شده است. لازم است که تداخل این پارامتر را با پارامترهای موجود بررسی کنید.
                        </p>
                    )}
                    {!!requiredsItems.length && (
                        <p className="pl-mb-4">
                            <span>{requiredsItems.length === 1 ? "پارامتر" : "پارامترهای"}</span> <span>{requiredsItems.join(" و ")}</span>{" "}
                            <span>{requiredsItems.length === 1 ? "الزامی است." : "الزامی هستند."}</span>
                        </p>
                    )}
                    {!!notRequiredsItems.length && (
                        <p>
                            <span>{notRequiredsItems.length === 1 ? "پارامتر" : "پارامترهای"}</span> <span>{notRequiredsItems.join(" و ")}</span>{" "}
                            <span>{notRequiredsItems.length === 1 ? "به اشتباه وارد شده است." : "به اشتباه وارد شده اند."}</span>
                        </p>
                    )}
                </div>
                <Image src={IMAGES.danger1} width={352} height={198} />
            </div>
        </Popover>
    );
};

export default ParamsErrorPopover;
